import { BaseEditModel } from "model/BaseEditModel";
import Produto from "model/administracao/cadastro/produto/Produto";
import EstoqueLote from "./EstoqueLote";



export default class ItemTransferencia implements BaseEditModel {
    key: string | null = null;
    id: number;
    sequencial: number | null;
    produto: Produto;
    lote: EstoqueLote | null;
    quantidade: number;
    valorUnitario: number;

    constructor(
        id = 0,
        sequencial = 0,
        produto = new Produto(),
        lote = new EstoqueLote(),
        quantidade = 0,
        valorUnitario = 0
    ) {
        this.id = id;
        this.sequencial = sequencial;
        this.produto = produto;
        this.lote = lote;
        this.quantidade = quantidade;
        this.valorUnitario = valorUnitario;
    }

}